import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const ComponentTitle = styled.div`
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.m};
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const GridItem = styled.div<{
  $hasTopTitle?: boolean;
  $someHasTopTitle?: boolean;
}>`
  max-width: 340px;
  width: 100%;
  flex: 1;

  ${(props) =>
    !props.$hasTopTitle &&
    props.$someHasTopTitle &&
    css`
      @media (min-width: ${mobileBreakPointCSS}) {
        margin-top: 47px;
      }
    `}
`;

export const TopTitle = styled.div.attrs({ className: "b3" })`
  text-align: center;
  height: 47px;
  background-color: var(--swatch3);
  color: var(--swatch2);
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  text-align: center;
`;

export const Card = styled.div`
  background-color: var(--swatch3);
  color: var(--swatch2);
  border-radius: ${(props) => props.theme.borderRadius};
  overflow: hidden;
`;

export const Title = styled.h3`
  margin: 0;
  background-color: var(--swatch1);
  color: #fff;
  text-align: center;
  padding: ${(props) => props.theme.spacing.m};
`;

export const Content = styled.div`
  padding: ${(props) => props.theme.spacing.m};
`;

export const Cta = styled.div`
  text-align: center;
  margin-top: ${(props) => props.theme.spacing.l};

  .product-price {
    margin-bottom: ${(props) => props.theme.spacing.m};
  }

  button  {
    display: inline-block;
    min-width: 225px;
    margin-top: ${(props) => props.theme.spacing.s};
  }
`;

export const ContentListWrapper = styled.div`
  border-top: 1px solid var(--swatch2);
`;

export const ContentListHeading = styled.a.attrs({ className: "b2" })<{
  $expanded?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  color: inherit;
  text-decoration: none;
  padding: ${(props) => `${props.theme.spacing.s} ${props.theme.spacing.m}`};

  svg {
    height: 24px;
    width: 24px;

    path {
      fill: var(--swatch2);
    }

    ${(props) =>
      props.$expanded &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const LogoGrid = styled.ul`
  display: grid;
  margin: 0;
  padding: 0 ${(props) => `${props.theme.spacing.m} ${props.theme.spacing.m}`};
  grid-gap: ${(props) => props.theme.spacing.m};
  list-style-type: none;
  grid-template-columns: repeat(3, 1fr);
`;

export const LogoGridItem = styled.li`
  margin: 0;
  padding: 0;

  img {
    display: block;
    width: 70px;
    height: 70px;
  }

  p {
    margin: 0;
    text-align: center;
  }
`;

export const List = styled.ul<{ removeListStyle?: boolean }>`
  margin: 0;
  padding: 0 ${(props) => `${props.theme.spacing.m} ${props.theme.spacing.m}`};
  list-style-type: none;

  ${(props) =>
    props.removeListStyle &&
    css`
      list-style-type: disc;
    `};
`;

interface ListItemProps {
  disabled?: boolean;
}

export const ListItem = styled.li<ListItemProps>`
  display: flex;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 50%;

      svg {
        fill: var(--swatch2) !important;
      }
    `}

  &:not(:last-child) {
    margin-bottom: ${(props) => props.theme.spacing.xs};
  }
`;

export const ListItemIcon = styled.div`
  width: 24px;
  height: 24px;
  margin-right: ${(props) => props.theme.spacing.s};
  position: relative;

  svg {
    position: absolute;
    top: 0;
    fill: var(--swatch2);
    height: 24px;
    width: 24px;
  }
`;
